import {
  Directive,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
  Optional,
  Input
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appFieldError]'
})
export class FieldErrorDirective implements OnInit, OnDestroy {

  private subscription?: Subscription;
  private errorDiv?: HTMLElement;

  private _translateStrings: any = {};

  @Input()
  set translateStrings(value: any) {
    this._translateStrings = value || {};
    this.updateErrorMessages();
    this.checkAndShowError();
  }

  @Input() fieldName?: string;

  private errorMessages: { [key: string]: string } = {
    required: '',
    email: '',
    homephone: '',
    htmlTags: '',
    pattern: '',
    custom: ''
  };

  constructor(
    @Optional() private ngControl: NgControl,
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (!this.ngControl?.control) return;

    this.el.nativeElement.addEventListener('blur', () => {
      this.ngControl.control?.markAsTouched();
      this.checkAndShowError();
    });

    this.subscription = this.ngControl.control.valueChanges?.subscribe(() => {
      this.checkAndShowError();
    });

    this.checkAndShowError();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.removeError();
  }

  private updateErrorMessages(): void {
    this.errorMessages = {
      required: this._translateStrings.MsgRequired,
      email: this._translateStrings.MsgEmail,
      homephone: this._translateStrings.MsgPhone,
      htmlTags: this._translateStrings.MsgInvalidInputHtmlTag,
      pattern: this._translateStrings.MsgInvalidPattern,
      custom: ''
    };
  }

  private checkAndShowError(): void {
    this.removeError();

  const control = this.ngControl?.control;
  if (!control || !control.touched || !control.invalid) return;

  const input = this.el.nativeElement;
  const parent = input.parentElement;
  if (!parent) return;

  this.renderer.addClass(parent, 'invalid');
  this.renderer.addClass(parent, 'shake');

  this.errorDiv = this.renderer.createElement('div');
  this.renderer.addClass(this.errorDiv, 'error-text');

  const icon = this.renderer.createElement('i');
  this.renderer.addClass(icon, 'fa');
  this.renderer.addClass(icon, 'fa-times-circle');
  this.renderer.appendChild(this.errorDiv, icon);

    const errors = control.errors || {};
    const errorKey = Object.keys(errors)[0];

    const fieldKey =
      this.fieldName || (input.name || input.id || '').toLowerCase();

    const message =
      errors['custom'] ||
      this._translateStrings[fieldKey] ||
      this.errorMessages[errorKey];

  const text = this.renderer.createElement('span');
  this.renderer.addClass(text, 'error-text');
  this.renderer.setProperty(text, 'textContent', message);
  this.renderer.appendChild(this.errorDiv, text);

  this.renderer.insertBefore(parent, this.errorDiv, input.nextSibling);

  setTimeout(() => this.renderer.removeClass(parent, 'shake'), 500);
}

  private removeError(): void {
    if (this.errorDiv?.parentNode) {
      this.renderer.removeChild(this.errorDiv.parentNode, this.errorDiv);
      this.errorDiv = undefined;
    }

    const parent = this.el.nativeElement.parentElement;
    if (parent) {
      this.renderer.removeClass(parent, 'invalid');
      this.renderer.removeClass(parent, 'shake');
    }
  }
}
